import { render, staticRenderFns } from "./AvatarDialog.vue?vue&type=template&id=8534867c&scoped=true&"
import script from "./AvatarDialog.vue?vue&type=script&lang=ts&"
export * from "./AvatarDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AvatarDialog.vue?vue&type=style&index=0&id=8534867c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8534867c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
